(function () {
  function processParagraph(p) {
    if (!p || p.dataset.labelBoldified === "1") return;


    const text = (p.textContent || "").trim();
    if (!text.includes(":")) return;


    // Split solo al primo ":" così non rompi valori che contengono ":" dopo
    const idx = text.indexOf(":");
    const label = text.slice(0, idx + 1);
    const rest = text.slice(idx + 1);


    // Evita di toccare paragrafi vuoti o strani
    if (!label || !rest) return;


    p.innerHTML = "<strong>" + escapeHtml(label) + "</strong>" + escapeHtml(rest);
    p.dataset.labelBoldified = "1";
  }


  function escapeHtml(str) {
    return str
      .replaceAll("&", "&")
      .replaceAll("<", "<")
      .replaceAll(">", ">");
  }


  function run(root = document) {
    root
      .querySelectorAll(".product-tabs__tab-item-content.rte p")
      .forEach(processParagraph);
  }


  // Prima passata
  document.addEventListener("DOMContentLoaded", function () {
    run();


    // Se le tab/accordion aggiornano il DOM dopo (molto comune su Focal/Horizon)
    const target = document.querySelector(".product-tabs") || document.body;
    const obs = new MutationObserver(function () {
      run();
    });


    obs.observe(target, { childList: true, subtree: true });
  });
})();

(function () {
  function cleanFilterLabels(root = document) {
    root
      .querySelectorAll(".product-facet__filter-item label")
      .forEach(function (label) {
        const text = label.textContent.trim();
        if (!text.includes(":")) return;

        // Prende solo la parte dopo i ":"
        const idx = text.indexOf(":");
        let cleaned = text.slice(idx + 1).trim();

        // Mette la prima lettera maiuscola
        cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);

        label.textContent = cleaned;
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    cleanFilterLabels();

    const target = document.querySelector(".product-facet") || document.body;
    const obs = new MutationObserver(function () {
      cleanFilterLabels();
    });

    obs.observe(target, { childList: true, subtree: true });
  });
})();